import {
  Component,OnInit,Output,ViewChild} from '@angular/core';
import {ActivatedRoute,Router} from '@angular/router';
import {Table} from 'primeng/table';
import {Modules,LocalStorage,SubMenues,MenuItemsAccess} from 'src/app/appCommon/Enums/enum';
import {DefineService} from 'src/app/appServices/DefineService/define-service';
import {HelperService} from 'src/app/appServices/HelperService/helper.service';
import {FormBuilder,FormGroup,Validators} from '@angular/forms';
import {MessageService} from 'primeng/api';
import {PiteamService} from 'src/app/appServices/DefineService/piTeam-service';
import {ObservableService} from 'src/app/appServices/ObservableService/observable.service';
import { AnalyzeService } from 'src/app/appServices/AnalyzeService/analyzeService.service';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { contactRoleOptions } from 'src/app/appWeb/shared/shared';
import { AccessControlService } from 'src/app/appServices/CommonService/access-control.service';
import { facilityContact, facilitySystemList, facilityType, qualityGoal, response, teleneuroQPS, timeZone } from 'src/app/appWeb/shared/shared-interface';

import { object } from '../../../../shared/shared';
import { AuthService } from 'src/app/appServices/AuthService/auth.service';
@Component({
  selector: 'app-facility-specs',
  templateUrl: './facility-specs.component.html',
  styleUrls: ['./facility-specs.component.scss'],
})
export class FacilitySpecsComponent implements OnInit {
  @ViewChild('dt') dt: Table | undefined;
  // qualityGoal: Array<qualityGoal> = [];
  @Output() facilitySpecsGrid: any = [];
  allQualityGoal: Array<qualityGoal> = [];
  QualityGoalsURL:string = '';
  FacilityName: string = '';
  response_GetFacilityDetailByFacilityId!: response;
  specBool:boolean = false;
  form!: FormGroup;
  formContact!: FormGroup;
  facilityID:string = '';
  buttonText:string = 'saveContact';
  pageNumber:number = 1;
  rows:number = 15;
  sortOrder:string = 'Asc';
  sortCol:string = '';
  filterVal:string = '';
  searchField:string = '';
  facilityContact: Array<facilityContact> = [];
  addEditContactDialog:boolean = false;
  contactRoleOptions = contactRoleOptions;
  UId: string | null= '';
  UName: string | null= '';
  saveFacilityContactData: any;
  cnt_key!: number;
  @Output() totalRecords:number = 0;
  cols: any;
  checked: boolean = false;
  facilityOrContact:string = 'Facility Information';
  showProgressSpinner: boolean = false;
  faciltyPanelBool:number = 0;
  noRecordBool!: boolean;
  toastType:string = "";
  onClickDisable: boolean = false;
  disabledButton: boolean = true;
  cntMobilePhoneBool: boolean = false;
  cntPrimaryPhone: boolean = false;
  displayBackButton: boolean = false;
  crossSearchBool: boolean = false;

  @Output() isAccessReadWrite: boolean = false;
  roleAccessResult: any = [];
  RoleName: string = '';
  @Output() isAccessRead: boolean = false;
  facilityList: Array<facilitySystemList> = [];
  facilityListTemp:Array<facilitySystemList> = [];
  systemList: Array<facilitySystemList> = [];
  regiionalList: Array<facilitySystemList> =[];
  stateList: Array<facilitySystemList> = [];
  datePipe = new DatePipe('en-US');
  Facility_Type: Array<facilityType> =[];
  Time_Zone: Array<timeZone> =[];
  Teleneuro_QPS: Array<teleneuroQPS> =[];
  Medical_Director: Array<teleneuroQPS> =[];
  accessFacility:string = '';
  teleUrl: string = environment.teleUrl;
  telePsychBool: boolean = true;
  selectedSystem: Array<string> = [];
  systemListTemp:Array<facilitySystemList> = [];
  selectedFacility: Array<string> = [];
  editScreen: boolean = false;
  private subscription: Subscription[] = [];
  activeTab: number = 0;
  lazyLoadSearchBool: boolean = false;
  @Output() roleForFacility: boolean = false;
  showToast: boolean = false;
  constructor(
    private defineService: DefineService,
    private helperService: HelperService,
    private fb: FormBuilder,
    private messageService: MessageService,
    public PiTeamService: PiteamService,
    private Observable: ObservableService,
    private analyzeService: AnalyzeService,
    private router: Router,
    private route: ActivatedRoute,
    private accessControlService: AccessControlService,
    private authService: AuthService
    

  ) {
    this.QualityGoalsURL =
      Modules.Layout + '/' + Modules.Define + '/' + SubMenues.QualityGoals;
  }

  ngOnInit(): void {
    this.createForm();
    this.addContactForm();
    this.UId = this.helperService.decryption(localStorage.getItem(LocalStorage.UId));
    this.UName = this.helperService.decryption(localStorage.getItem(LocalStorage.UName));
    this.RoleName = this.helperService.decryption(localStorage.getItem(LocalStorage.UserRoleName));
    this.roleForFacility = this.authService.roleForFacility();
    
    // this.getAllValuesOfFilter();
    let row: any
    let page: any;
    let filter: any;
    this.subscription.push(
    this.route.queryParamMap.subscribe((params: any) => {
      if(Boolean(params.get('getUserDetail'))){
      const getCase = params.get('getUserDetail');
      const getCaseDetail = Boolean(getCase);
      const edit = params.get('editScreen');
      this.editScreen = Boolean(edit);
      const FacilityID = params.get('FacilityID')
      const FacilityName = params.get('FacilityName')
      const screenStatus = params.get('screenStatus');
      row = params.get('r');
      page = params.get('p');
      filter = params.get('f');

      if (getCaseDetail && screenStatus == 'Edit') {
        this.getFacilityDetailByFacilityId(FacilityID, FacilityName);
      } else if (getCaseDetail && screenStatus == 'View') {
        this.getFacilityDetailByFacilityId(FacilityID, FacilityName);
      }
      this.specBool = true;
      this.analyzeService.ClearQueryParams();
    }
    })
    );
    if (this.editScreen) {
      this.rows = row;
      this.pageNumber = page;
      this.searchField = filter;
      this.getAllFacilities();
    }
  }

  ngAfterContentInit(): void {
    if (!this.editScreen) {
      this.Observable.value$.subscribe((val) => {
        this.specBool = val;
        this.searchField = '';
      });
    }
  }

  getAllFacilities() {
    this.showProgressSpinner = true;
    let data = {
      Take: this.rows,
      Skip: this.rows * this.pageNumber - this.rows,
      Sort: {
        FieldName: this.editScreen?'FacilityName':this.sortCol,
        Order: this.sortOrder,
      },
      Filter: {
        field: '',
        operator: '',
        value: this.searchField,
        logic: '',
        filters: [],
      },
      searchString: this.searchField,
      PageNumber: this.pageNumber,
      serviceType: [],
      roleIDs: [],
    };

    var model = {
      request: data,
      roleName:this.RoleName,
      userId: this.UId,
      System: this.selectedSystem.join(','),
      Facility: this.selectedFacility.join(',')
    }
    this.subscription.push(
    this.defineService.GetAllFacilities(model).subscribe({
      next: (res: any) => {
        if (res.data.length == 0) {
          this.noRecordBool = true;
        } else {
          this.noRecordBool = false;
        }
        if (res.data) {
          this.allQualityGoal = res.data;
          this.facilitySpecsGrid = res.data;
          this.totalRecords = res.Total;
        }
        this.showProgressSpinner = false;
        this.PiTeamService.currentDateTime();

        const accessData = this.accessControlService.checkAccess( MenuItemsAccess.FacilitySpecsRead, MenuItemsAccess.FacilitySpecsReadWrite);
        this.isAccessRead = accessData.isAccessRead;
        this.isAccessReadWrite = accessData.isAccessReadWrite;
      },
      error: (err: any) => {},
    })
    );
  }

  createForm() {
    this.form = this.fb.group({
      fac_participation_PI_reporting: [false],
      fac_participation_RAPID_I: [false],
      fac_hospital_CTA_protocol: [''],
      fac_name: [''],
      fac_ucd_key_system: [''],
      fac_ucd_region_key: [''],
      fac_fct_key: [''],
      fac_freestanding_fac_key: [''],
      fac_address_line1: [''],
      fac_address_line2: [''],
      fac_city: [''],
      fac_stt_key: [''],
      fac_zip: [''],
      fac_timezone: [''],
      fac_md_staff_source_name: [''],
      fac_md_staff_reference_source_id: [{ value:'', disabled: true}],
      fac_ts_account_ID: [''],
      fac_short_name: [''],
      fac_facility_id: [''],
      fac_pulsara_id: [''],
      fac_go_live_date: [''],
      fac_go_live_date_telepsych: [''],
      fac_go_live: [false],
      fac_added_from_go_live: [false],
      fac_is_active: [false],
      fac_dispatch_priority: [false],
      fac_pre_activation: [false],
      fac_stroke_Kits: [false],
      fac_pit_stop_process: [false],
      fac_early_alteplase_mix: [false],
      fac_stroke_assessment_tool: [false],
      fac_cart_to_CT: [false],
      fac_bedside_mixing_of_alteplase: [false],
      fac_alteplase_administration_in_CT: [false],
      fac_designated_stroke_team: [false],
      qps_number: [''],
      fac_medicaldirector_assigned:[''],
      fac_go_live_telepsych:['']

    });
  }

  get f() {
    return this.form.controls;
  }

  submit() {
    this.onClickDisable = true;
    this.showProgressSpinner = true;
    this.form.value.fac_go_live_date = this.datePipe.transform(this.form.value.fac_go_live_date,'MM/dd/yyyy');
    this.form.value.fac_go_live_date_telepsych = this.datePipe.transform(this.form.value.fac_go_live_date_telepsych,'MM/dd/yyyy');
    this.subscription.push(
    this.defineService
      .SaveFacilitySpec(this.facilityID, this.form.value)
      .subscribe({
        next: (res: any) => {
          this.messageService.add({
            key: 'save',
            severity: 'success',
            summary: 'Success',
            detail: 'Facility Spec Added Successfuly.',
          });
          this.showProgressSpinner = false;
          this.onClickDisable = false;
        },
        error: (err: any) => {},
      })
      );
  }

  GetAllData(val:string){
    if((this.facilityList.length === 0 && val == 'facility') || 
    (this.systemList.length === 0 && val == 'system') || 
    (this.regiionalList.length === 0 && val == 'regional') || 
    (this.stateList.length === 0 && val == 'state')){
    let obj = object;
    if(val == 'system'){
      obj.FieldName = 'ucd_ucl_key';
      obj.Value = '42';
    }else if(val == 'facility'){
      obj.FieldName = 'facility';
      obj.Value = 'facility';
    }else if('regional'){
      obj.FieldName = 'ucd_ucl_key';
      obj.Value = '43';
    }else if('state'){
      obj.FieldName = 'ucd_ucl_key';
      obj.Value = '21';
    }
    this.subscription.push(
      this.analyzeService.GetAllData(obj,this.RoleName,this.UId).subscribe({
        next: (res: any) => {
          if (res) {
            if(val == 'system'){
              this.systemList = res.data;
              this.systemListTemp = res.data;
            }else if(val == 'facility'){
              this.facilityList = res.data;
              this.facilityListTemp = res.data;
            }else if(val == 'regional'){
              this.regiionalList = res.data;
            }else if(val == 'state'){
              this.stateList = res.data;
            }
          }
        },
        error: (err: any) => { },
      })
      );
    }
  }
  GetFacility(){
    if(this.selectedSystem.length > 0){
      this.subscription.push(
      this.analyzeService.GetFacilityBySystem(this.selectedSystem).subscribe({
        next: (res: any) => {
          if(res){
            this.facilityList = res.data.data;
            this.getAllFacilities();
          }
        },
        error: (err: any) => { 
        },
      })
      );
    }else{
      this.systemList = this.systemListTemp;
      this.selectedFacility = [];
      this.facilityList = this.facilityListTemp;
      this.getAllFacilities();
    }
  }

  OnFacilityChange(){
    this.getAllFacilities();
  }
  getFacilityDetailByFacilityId(FacilityID: string, FacilityName: string) {
    this.displayBackButton = true;
    this.facilityID = FacilityID.toLocaleLowerCase();
    this.FacilityName = FacilityName;
    this.checked = true;
    this.showProgressSpinner = true;
    if(this.roleForFacility){
      this.isAccessRead = true;
      this.isAccessReadWrite = false;
    }
    this.GetAllData('facility');
    this.activeTab = 0;
    this.subscription.push(
    this.defineService.GetFacilityDetailByFacilityId(FacilityID).subscribe({
      next: (res: any) => {
        this.response_GetFacilityDetailByFacilityId = res.data.result;
        this.Facility_Type = res.data.Facility_Type;
        this.Time_Zone = res.data.Time_Zone;
        this.Teleneuro_QPS = res.data.Teleneuro_QPS;
        this.Medical_Director = res.data.Medical_Director;
        if(res?.data?.TelePsychModel?.fct_cvr_telepsych_key == 0){
          this.telePsychBool = false;
        }else{
          this.telePsychBool = true;
        }

        this.showProgressSpinner = false;

if(this.response_GetFacilityDetailByFacilityId.fac_go_live_date){
  this.response_GetFacilityDetailByFacilityId.fac_go_live_date = this.datePipe.transform(
    this.response_GetFacilityDetailByFacilityId.fac_go_live_date,'MM/dd/yyyy'
  );
}
if(this.response_GetFacilityDetailByFacilityId.fac_go_live_date_telepsych){
  this.response_GetFacilityDetailByFacilityId.fac_go_live_date_telepsych = this.datePipe.transform(
    this.response_GetFacilityDetailByFacilityId.fac_go_live_date_telepsych,'MM/dd/yyyy'
  );
}
if(this.response_GetFacilityDetailByFacilityId.fac_ucd_key_system != null){
  this.response_GetFacilityDetailByFacilityId.fac_ucd_key_system =  this.response_GetFacilityDetailByFacilityId.fac_ucd_key_system.toString();
}
if(this.response_GetFacilityDetailByFacilityId.fac_ucd_region_key != null){
  this.response_GetFacilityDetailByFacilityId.fac_ucd_region_key = this.response_GetFacilityDetailByFacilityId.fac_ucd_region_key.toString();
}
if(this.response_GetFacilityDetailByFacilityId.fac_freestanding_fac_key != null){
  this.response_GetFacilityDetailByFacilityId.fac_freestanding_fac_key = this.response_GetFacilityDetailByFacilityId.fac_freestanding_fac_key.toString();
}
if(this.response_GetFacilityDetailByFacilityId.fac_stt_key != null){
  this.response_GetFacilityDetailByFacilityId.fac_stt_key = this.response_GetFacilityDetailByFacilityId.fac_stt_key.toString();
}
this.form.patchValue(this.response_GetFacilityDetailByFacilityId);
        this.specBool = true;
      },
      error: (err: any) => {},
    })
    );
  }

  backToSpec(type: string) {
    this.showToast = true;
    this.toastType = type;
    this.messageService.clear();
    this.messageService.add({
      key: 'c',
      sticky: true,
      severity: 'custom',
      summary: 'Are you sure you want to close out of this page?'
    });
  }

  onConfirm() {
    this.showToast = false;
    if (this.toastType == "Delete") {
      this.defineService.RemoveFacilityContact(this.cnt_key).subscribe({
        next: (res: any) => {
          if (res.msg) {
            this.messageService.clear();
            this.totalRecords = this.totalRecords - 1;

            this.messageService.add({
              key: 'save',
              severity: 'success',
              summary: 'Success',
              detail: 'Contact Deleted Successfuly'
            }); //zaid
            for (
              let index = 0; index < this.facilityContact.length; index++
            ) {
              if (this.facilityContact[index].cnt_key == this.cnt_key) {
                this.facilityContact.splice(index, 1);
              }
            }
          }
        },
        error: (err: any) => {

        },
      });
    }
    if (this.toastType == "Cancel") {
      this.specBool = false;
      this.messageService.clear();
    } else if (this.toastType == "hideContactDiaglog") {
      this.addEditContactDialog = false;
      this.messageService.clear();
    }

  }

  onReject() {
    this.showToast = false;
    this.messageService.clear();
  }

  AccessFacility() {
    this.accessFacility = this.teleUrl + `Facility/Edit/${this.facilityID}?showPopupOnLoad=true`;
    window.open(this.accessFacility);
  }

  GetFacilityContact() {
    let data = {
      Take: this.rows,
      Skip: this.rows * this.pageNumber - this.rows,
      Sort: {
        FieldName: this.sortCol,
        Order: this.sortOrder,
      },
      Filter: {
        field: '',
        operator: '',
        value: '',
        logic: '',
        filters: [],
      },
      searchString: '',
      PageNumber: this.pageNumber,
      serviceType: [],
      roleIDs: [],
    };
    this.showProgressSpinner = true;
    this.subscription.push(
    this.defineService.GetFacilityContact(this.facilityID, data).subscribe({
      next: (res: any) => {
        if (res.data.length == 0) {
          this.noRecordBool = true;
        } else {
          this.noRecordBool = false;
        }
        if (res.data) {
          this.facilityContact = res.data;
          for (let index = 0; index < this.facilityContact.length; index++) {
            this.facilityContact[index].cnt_mobile_phone = this.formatPhoneNumber(this.facilityContact[index].cnt_mobile_phone);
            this.facilityContact[index].cnt_primary_phone = this.formatPhoneNumber(this.facilityContact[index].cnt_primary_phone);
          }
          this.totalRecords = res.Total;
        }
        this.showProgressSpinner = false;
        this.PiTeamService.currentDateTime();
      },
      error: (err: any) => {

      },
    })
    );
  }
  formatPhoneNumber(phone: string | null): string {
    if (phone && phone !== "") {
      const array = phone.split("").map(Number);
      return `(${array[0]}${array[1]}${array[2]}) ${array[3]}${array[4]}${array[5]}-${array[6]}${array[7]}${array[8]}${array[9]}`;
    } else {
      return "";
    }
  }

  addContact() {
    this.addEditContactDialog = true;
    this.cntMobilePhoneBool = false;
    this.cntPrimaryPhone = false;
    this.buttonText = 'saveContact';
    this.addContactForm();
  }

  editContact(facilityContact: facilityContact) {
    this.onClickDisable = false;
    this.addEditContactDialog = true;
    this.buttonText = 'editContact';
    let indexOfContactRole = this.contactRoleOptions.findIndex((obj) => {
      return obj.name == facilityContact.cnt_role_name;
    });
    if (facilityContact.cnt_role_ucd_key == null) {
      facilityContact.cnt_role_ucd_key = 0;
    }
    this.formContact.patchValue(facilityContact);
  }

  hideContactDiaglog() {
    this.addEditContactDialog = false;
  }

  addContactForm() {
    this.formContact = this.fb.group({
      cnt_key: [''],
      cnt_first_name: [''],
      cnt_last_name: [''],
      cnt_role_ucd_key: [''],
      cnt_role: [''],
      cnt_primary_phone: ['', Validators.required],
      cnt_extension: [''],
      cnt_mobile_phone: ['', Validators.required],
      cnt_email: ['', [Validators.required, Validators.email]],
      cnt_is_active: [true],
    });
  }

  get fc() {
    return this.formContact.controls;
  }

  submitContact() {
    let obj = {
      cnt_first_name: this.formContact.value.cnt_first_name,
      cnt_last_name: this.formContact.value.cnt_last_name,
      cnt_role_ucd_key: this.formContact.value.cnt_role_ucd_key,
      cnt_role: this.formContact.value.cnt_role,
      cnt_primary_phone: this.formContact.value.cnt_primary_phone,
      cnt_extension: this.formContact.value.cnt_extension,
      cnt_mobile_phone: this.formContact.value.cnt_mobile_phone,
      cnt_email: this.formContact.value.cnt_email,
      cnt_is_active: this.formContact.value.cnt_is_active,
      cnt_fac_key: this.facilityID,
      cnt_created_by: this.UId,
      cnt_created_by_name: this.UName,
      cnt_key: 0,
    };
    this.showProgressSpinner = true;
    this.subscription.push(
    this.defineService.CreateFacilityContact(obj).subscribe({
      next: (res: any) => {
        if (res.data) {
          this.messageService.add({
            key: 'Contact',
            severity: 'success',
            summary: 'Success',
            detail: 'Contact Added Successfuly'
          });
          this.showProgressSpinner = false;
          this.disabledButton = true;
          this.saveFacilityContactData = res.data;
          this.GetFacilityContact();
          this.addEditContactDialog = false;
        }
      },
      error: (err: any) => {

      },
    })
    );
  }

  editFacilityContact() {
    this.onClickDisable = true;
    let obj = {
      cnt_first_name: this.formContact.value.cnt_first_name,
      cnt_last_name: this.formContact.value.cnt_last_name,
      cnt_role_ucd_key: this.formContact.value.cnt_role_ucd_key,
      cnt_role: this.formContact.value.cnt_role,
      cnt_primary_phone: this.formContact.value.cnt_primary_phone,
      cnt_extension: this.formContact.value.cnt_extension,
      cnt_mobile_phone: this.formContact.value.cnt_mobile_phone,
      cnt_email: this.formContact.value.cnt_email,
      cnt_is_active: this.formContact.value.cnt_is_active,
      cnt_fac_key: this.facilityID,
      cnt_modified_by: this.UId,
      cnt_modified_by_name: this.UName,
      cnt_key: this.formContact.value.cnt_key,
    };
    this.showProgressSpinner = true;
    this.subscription.push(
    this.defineService.EditFacilityContact(obj).subscribe({
      next: (res: any) => {
        if (res.data) {
          this.messageService.add({
            key: 'Contact',
            severity: 'success',
            summary: 'Success',
            detail: 'Contact Updated Successfuly'
          });
          this.saveFacilityContactData = res.data;
          this.GetFacilityContact();
          this.addEditContactDialog = false;
          this.showProgressSpinner = false;
          this.onClickDisable = false;
        }
      },
      error: (err: any) => {

      },
    })
    );
  }

  deleteFacilityContact(facilityContact: any) {
    this.cnt_key = facilityContact.cnt_key;
    this.toastType = "Delete";
    this.messageService.clear();
    this.messageService.add({
      key: 'c',
      sticky: true,
      severity: 'custom',
      summary: 'Are you sure you want to delete?'
    });
  }

  async applyFilterGlobal($event: any, stringVal: string) {
    const inputValue = ($event.target as HTMLInputElement).value;
    this.dt = await this.defineService.getDtTable();
    this.dt!.filterGlobal(inputValue, stringVal);
    if(inputValue !== ''){
      this.crossSearchBool = true;
    }else{
    this.crossSearchBool = false;
    }
  }
  clearSearchField() {
    this.crossSearchBool = false;
    this.searchField = '';
    this.getAllFacilities();
   
  }

  lazyLoadSchedulesForSpec(event: any) {
    if (event != undefined) {
      this.rows = event.rows;
      this.pageNumber = event.first / this.rows + 1;
      this.sortOrder =
        event.multiSortMeta == undefined || event.multiSortMeta[0].order == 1 ?
        'ASC' :
        'DESC';
      this.sortCol =
        event.multiSortMeta == undefined ? 'FacilityName' : event.multiSortMeta[0].field;
      this.filterVal =
        event.filters.global == undefined ? '' : event.filters.global.value;
        this.searchField.length > 0 ? this.crossSearchBool = true : this.crossSearchBool = false;
      this.getAllFacilities();
    }
  }

  lazyLoadSchedulesForContact(event: any) {
    if (event != undefined && this.activeTab == 1) {
      this.rows = event.rows;
      this.pageNumber = event.first / this.rows + 1;
      this.sortOrder =
        event.multiSortMeta == undefined || event.multiSortMeta[0].order == 1 ?
        'ASC' :
        'DESC';
      this.sortCol =
        event.multiSortMeta == undefined ? '' : event.multiSortMeta[0].field;
      this.filterVal =
        event.filters.global == undefined ? '' : event.filters.global.value;
          this.GetFacilityContact();
    }
  }

  switchHeaders(tabNumber: any) {
    this.activeTab = tabNumber.index;
    switch (this.activeTab) {
      case 0: this.getFacilityDetailByFacilityId(this.facilityID, this.FacilityName); break;
      case 1: this.GetFacilityContact(); break;
    }
  }

  updateFaciiltyDataViaDropdown() {
    let result:any = this.facilityList.filter((item: any) => item.Value.toLocaleLowerCase() == this.facilityID);
    this.FacilityName = result[0].Text;
    switch (this.activeTab) {
      case 0: this.getFacilityDetailByFacilityId(this.facilityID, this.FacilityName); break;
      case 1: this.GetFacilityContact(); break;
    }
  }

  checkPhoneValidation(FieldName: string) {
    if (FieldName == 'cnt_mobile_phone') {
      if (this.formContact.value.cnt_mobile_phone != "") {
        this.formContact.controls['cnt_primary_phone'].setValidators([]);
        this.formContact.controls['cnt_primary_phone'].updateValueAndValidity();
        this.cntPrimaryPhone = true;
      } else {
        this.formContact.controls['cnt_primary_phone'].setValidators([Validators.required]);
        this.formContact.controls['cnt_primary_phone'].updateValueAndValidity();
        this.cntPrimaryPhone = false;
      }
    }
    if (FieldName == 'cnt_primary_phone') {
      if (this.formContact.value.cnt_primary_phone != "") {
        this.formContact.controls['cnt_mobile_phone'].setValidators([]);
        this.formContact.controls['cnt_mobile_phone'].updateValueAndValidity();
        this.cntMobilePhoneBool = true;
      } else {
        this.formContact.controls['cnt_mobile_phone'].setValidators([Validators.required]);
        this.formContact.controls['cnt_mobile_phone'].updateValueAndValidity();
        this.cntMobilePhoneBool = false;
      }
    }
  }

  routeBack() {
    this.specBool = false;
  }

  onContextMenu(event: { $event: MouseEvent; facilityId: string; facilityName: string; type: string }) {
    const { $event, facilityId, facilityName, type } = event;
    this.handleContextMenu($event, facilityId, facilityName, type);
  }
  handleContextMenu(event: MouseEvent, facilityId: string, facilityName: string, type: string) {
    event.preventDefault();
    const queryParams = {
      getUserDetail: true,
      editScreen: true,
      FacilityID: facilityId,
      FacilityName: facilityName,
      screenStatus: type,
      r: this.rows,
      p: this.pageNumber,
      f: this.filterVal,
    };
    const url = this.router.createUrlTree(['/Home/Define/FacilitySpecs'], { queryParams });
    window.open(url.toString(), '_blank');
  }

  // onContextMenu(event:MouseEvent,FacilityID: string, FacilityName: string,status:string){
  //   event.preventDefault();
  //   const queryParams = {
  //     getUserDetail: true,
  //     editScreen: true,
  //     FacilityID: FacilityID,
  //     FacilityName: FacilityName,
  //     screenStatus:status,
  //     r:this.rows,
  //     p:this.pageNumber,
  //     f:this.filterVal
  //   };
  //   const url = this.router.createUrlTree(['/Home/Define/FacilitySpecs'], { queryParams });
  //   window.open(url.toString(), '_blank');
  // }


  onContextMenuPreventDefault(event:any){
    event.preventDefault();
    }
      ngOnDestroy() {
    if(this.subscription.length != 0){
      this.subscription.forEach((i:any)=>{
        i.unsubscribe();
      })
    }
    
    Object.getOwnPropertyNames(this)
    .filter(propName => Array.isArray((<any>this)[propName]))
    .forEach(propName => (<any>this)[propName] = []);

  }

}
